import { AddCircleRounded, ArticleRounded, EditRounded } from "@mui/icons-material"
import { Button, IconButton, Tooltip, Typography } from "@mui/material"
import { BoxFR } from "components/BoxCustom"
import { driverColNm } from "constants/driverConstant"
import { jobOrderColNm } from "constants/jobOrderConstant"
import dayjs from "dayjs"
import { pettyCashColNm } from "pages/Menu1/PettyCash/constant"
import { CloudDownloadRounded } from "resource/muiImport"
import { numberFormat } from "utils"

export const driverTripPaymentColumns = (handleInsertDriverTripPaymentRow)=> [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: 'ShowDetail',
    headerName: '',
    width: 50,
    align: 'center',
    renderCell: (params) => {
      return (
        <Tooltip title="รายละเอียดใบงาน" placement="top" followCursor>
          <IconButton size="small" sx={{ p: 0 }}>
            <ArticleRounded color="primary" />
          </IconButton>
        </Tooltip>
      )
    }
  },
  {
    field: 'AddData',
    headerName: '',
    width: 50,
    align: 'center',
    renderCell: (params) => {
      return (
        <Tooltip title="เพิ่มค่าเที่ยว" placement="top" followCursor>
          <IconButton size="small" sx={{ p: 0 }}>
            <AddCircleRounded color="primary" />
          </IconButton>
        </Tooltip>
      )
    }
  },
  {
    field: "JobOrdId",
    headerName: "เลขที่ใบงาน",
    width: 80,
  },
  {
    field: "StsTm",
    headerName: "วันที่วิ่งงาน",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "AptTm",
    headerName: "เวลานัดส่ง",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-";
    },
  },
  {
    field: "JobSNm",
    headerName: "ชื่องาน",
    width: 150,
  },
  // {
  //   field: "Loc",
  //   headerName: "สถานที่",
  //   valueGetter: ({ row: { TakePlc, Loc, RtnPlc } }) => `${TakePlc}-${Loc}-${RtnPlc}`,
  //   width: 250,
  // },
  {
    field: "TakePlc",
    headerName: jobOrderColNm.TakePlc,
    width: 100,
  },
  {
    field: "Loc",
    headerName: jobOrderColNm.Loc,
    minWidth: 180,
  },
  {
    field: "RtnPlc",
    headerName: jobOrderColNm.RtnPlc,
    width: 100,
  },
  {
    field: "ContSizeFull",
    headerName: jobOrderColNm.ContSizeFull,
    width: 70,
  },
  {
    field: "ContNo",
    headerName: jobOrderColNm.ContNo,
    width: 120,
  },
  {
    field: "GrpNm",
    headerName: driverColNm.GrpNm,
    width: 60,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    flex: 1,
    minWidth: 120
  },
  {
    field: "ContStsNms",
    headerName: "หน้าที่",
    width: 80,
  },
  {
    field: `ExpNm`,
    headerName: "รายได้",
    valueGetter: ({ value }) => value ?? 'ค่าเที่ยวพขร.',
    width: 130,
  },
  {
    field: `PayAmnt`,
    headerName: "จำนวนเงิน",
    width: 110,
    align: 'right',
    editable: true,
    type: "number",
    valueFormatter: ({ value }) => value === null || value === undefined ? '-' : numberFormat(value),
    renderCell: ({ row, value }) => <BoxFR>
      <Typography variant="body2">{value === null || value === undefined ? '-' : numberFormat(value)}</Typography>
      <IconButton sx={{ p: 0 }} onClick={()=>handleInsertDriverTripPaymentRow(row)}>
        <CloudDownloadRounded color="primary" />
      </IconButton>
    </BoxFR>
  },
  {
    field: "Rmk",
    headerName: jobOrderColNm.Rmk,
    flex: 1,
    minWidth: 150,
  },
  // {
  //   field: "OthExp",
  //   headerName: "ค่าอื่นๆ",
  //   minWith: 150,
  //   flex: 1
  // },
  {
    field: "SalDte",
    headerName: "คิดเงินดือน",
    width: 110,
    // valueFormatter: ({ value }) => value ? dayjs(value).format("MM/YYYY") : '',
    renderCell: ({ value }) => (
      <Button size="small" variant={value ? "outlined" : "contained"}>
        {value ? dayjs(value).format("MMMM YYYY") : "กำหนดเดือน"}
      </Button>
    )
  },
]

export const otherDriverTripColumns = [

  {
    field: 'ShowDetail',
    headerName: '',
    width: 50,
    align: 'center',
    renderCell: (params) => {
      return (
        <IconButton size="small" sx={{ p: 0 }}>
          <EditRounded color="primary" />
        </IconButton>
      )
    }
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "UsrAccNm",
    headerName: pettyCashColNm.UsrAccId,
    minWidth: 120,
    flex: 1
  },
  {
    field: "ExpNm",
    headerName: pettyCashColNm.ExpNm,
    minWidth: 120,
    flex: 1
  },
  {
    field: `Amnt`,
    headerName: pettyCashColNm.Amnt,
    width: 100,
    align: 'right',
    editable: true,
    type: "number",
    valueFormatter: ({ value }) => value === null || value === undefined ? '-' : numberFormat(value)
  },
  {
    field: "Dscp",
    headerName: pettyCashColNm.Dscp,
    minWidth: 120,
    flex: 1
  },
]